export default __webpack_public_path__ + "static/media/Twitter.551341a7.svg";